import type { ReactElement } from 'react';

import roxyMark from './assets/roxy-mark-clear.png';

export interface RoxyMarkProps {
  size?: number;
  className?: string;
}

export function RoxyMark({ size = 28, className }: RoxyMarkProps): ReactElement {
  return (
    <img
      src={roxyMark}
      alt=""
      width={size}
      height={size}
      className={className}
      draggable={false}
    />
  );
}
